var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82816 10.0004H3.51564C2.8694 10.0004 2.34376 9.47474 2.34376 8.82848V3.51577C2.34376 2.8695 2.8694 2.34384 3.51564 2.34384H8.82816C9.4744 2.34384 10 2.8695 10 3.51577V8.82848C10 9.47474 9.4744 10.0004 8.82816 10.0004ZM3.51564 3.12513C3.30024 3.12513 3.12501 3.30036 3.12501 3.51577V8.82848C3.12501 9.04388 3.30024 9.21912 3.51564 9.21912H8.82816C9.04355 9.21912 9.21878 9.04388 9.21878 8.82848V3.51577C9.21878 3.30036 9.04355 3.12513 8.82816 3.12513H3.51564ZM1.56251 6.87528H1.17188C0.956485 6.87528 0.781253 6.70004 0.781253 6.48463V1.17192C0.781253 0.95652 0.956485 0.781281 1.17188 0.781281H6.4844C6.69979 0.781281 6.87502 0.95652 6.87502 1.17192V1.54303H7.65628V1.17192C7.65628 0.525656 7.13064 0 6.4844 0H1.17188C0.525637 0 0 0.525656 0 1.17192V6.48463C0 7.1309 0.525637 7.65656 1.17188 7.65656H1.56251V6.87528Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.e980bb380c012f648690d058e1b43e4a.svg";
export { ForwardRef as ReactComponent };